import { SimpleModal, Box } from '@sequencehq/core-components'
import { Member } from '@stytch/react/b2b'
import { useTeamSettings } from '../useTeamSettings'
import { type ReactElement } from 'react'

export const RevokeInviteModal = ({
  member,
  trigger
}: {
  member: Member
  trigger: ReactElement
}) => {
  const { revokeInvite } = useTeamSettings()

  return (
    <SimpleModal
      variant="dialog"
      data-testid="team.revokeInvite.dialog"
      trigger={trigger}
      title="Revoke Invite"
      submitButtonText="Revoke"
      submittingButtonText="Revoking"
      isDestructive
      disableSubmitOnEnter
      onSubmit={async () => {
        await revokeInvite(member)
        return true
      }}
    >
      This will revoke the pending invite for <b>{member.email_address}</b>. You
      can invite them again afterwards.
    </SimpleModal>
  )
}
